import React, { Suspense } from "react";
import { ThemeProvider } from "styled-components";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import store from "./store";
import Routes from "./Routes";
import ErrorBoundary from "@components/Errors/ErrorBoundary";
import { setupAxiosInterceptors } from "@utils/authService";
import UserInfo from "@utils/UserInfo";
import "./i18n";
import "../css/app.css";
import "./App.scss";

// Setup axios interceptors for JWT token handling
setupAxiosInterceptors();
// Initialize global window vars from localStorage (JWT auth path).
// HTML page requests don't send JWT, so ReactEntryController can't set these
// twig-side. We hydrate them here so all existing API call sites keep working.
(() => {
  try {
    const stored = UserInfo.getUser();
    if (!stored) return;
    const countryId = UserInfo.countryId();
  } catch (e) {
    // ignore - bad JSON or storage access denied
  }
})();

const container = document.getElementById("rsg-root");
const root = createRoot(container);

// Set __DEV__ flag for development mode
window.__DEV__ = process.env.NODE_ENV === "development";

const theme = {
  colors: {
    primary: {
      main: "#004c7f",
      light: "#1bace4",
    },
    secondary: {
      main: "#93d5f6",
      dark: "#05719a",
      light: "#c9e8fb",
    },
    success: {
      main: "#7ac943",
    },
    error: {
      main: "#main",
    },
    warning: {
      main: "#ff9800",
    },
    info: {
      main: "#4a90e2",
    },
  },
  typography: {
    fontFamily: { main: "Lato", secondary: "Ubuntu" },
  },
  border: {
    radius: "4px",
  },
};

root.render(
  <Provider store={store}>
    <Suspense fallback={<div />}>
      <ThemeProvider theme={theme}>
        <ErrorBoundary>
          <Routes />
        </ErrorBoundary>
      </ThemeProvider>
    </Suspense>
  </Provider>
);
